// @flow

import * as React from "react";
import { FetcherUrl } from "../../Fetchers/FetcherUrl";
import { DictionaryManager } from "./DictionaryManager";
const _conn = new FetcherUrl();
const dictionaryManager = new DictionaryManager(_conn);
export const DictionaryManagerCtx: React$Context<DictionaryManager> = React.createContext<DictionaryManager>(dictionaryManager);
